import { Box, Typography } from '@mui/material'
import GppBadIcon from '@mui/icons-material/GppBad'

export function AdminWarning() {
  return (
    <Box display='flex' justifyContent='center' alignItems='center' mt={16}>
      <Box
        sx={{
          backgroundColor: 'error.main',
          p: 2,
          borderRadius: 2,
        }}
      >
        <Box display='flex' justifyContent='space-between'>
          <Typography variant='h5' color='error.contrastText'>
            Þú hefur ekki næg réttindi til þess að fara inn á þessa síðu.
          </Typography>
          <Box
            ml={2}
            mt={-0.5}
            sx={{ color: (theme) => theme.palette.primary.contrastText }}
          >
            <GppBadIcon fontSize='large' />
          </Box>
        </Box>
        <Box>
          <Typography variant='h6' color='error.contrastText'>
            Vinsamlegast hafðu samband við kerfisstjóra ef þú telur þig eiga
            hafa aðgang.
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
